export default __webpack_public_path__ + "static/media/9.11e34f9b.png";